<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog name="dialog" />
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      用户列表
    </div>
    <div class="admin_title">当前角色: {{form.name}}</div>
    <div class="gj_top_class">
      <a @click="delUsers(selected)" class="btn" style="background: #ff3633; padding-left: 23px;">批量删除</a>
      <a class="btn btn_add" @click="showRange">分配用户</a>
    </div>
    <div class="gj_list" style="min-height:670px;">
      <el-table v-if="tableData.data && tableData.data.length > 0"
                :data="tableData.data" stripe border @selection-change="updateSelected"
                style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="userName" label="用户名" sortable fixed>
        </el-table-column>
        <el-table-column label="操作" width="350" fixed="right">
          <template slot-scope="scope">
            <el-button @click="del(scope.row)" size="mini" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <h5 class="none_ts" v-if="tableData.data.length == 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="tableData.data.length > 0">共{{cnt}}条记录</dt>
        <dd v-if="tableData.data.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  import difference from 'lodash.differenceby'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    mounted () {
      this.search(this.filters)
    },
    created () {
      this.getModel(this.$route.params.id)
    },
    data () {
      return {
        lists: [],
        selected: [], // 选择的列表
        form: {},
        filters: {
          pageNo: 1,
          pageSize: 9,
          delFlag: '0'
        },
        cnt: 0,
        pages: 0,
        tableData: {
          data: []
        },
        publicStateList: []
      }
    },
    computed: {
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      updateSelected (val) {
        this.selected = val
      },
      to (path, id) {
        this.$router.push({
          name: path,
          params: {
            id: id
          }
        })
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      edit (item) {
        this.$router.push('/org/role/' + item.id)
      },
      distribute (item) {
        this.$router.push('/org/role/distribute/' + item.id)
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              var l = difference(that.tableData.data, [item], 'id')  // 求差集
              var ids = utils.grabVal(l, 'id')
              api.post(config.bylBaseCenterPath, '/user/role/add/role/user', {roleId: that.$route.params.id, userIds: ids}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      delUsers (items) {
        if (items.length > 0) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              var l = difference(that.tableData.data, items, 'id')  // 求差集
              var ids = utils.grabVal(l, 'id')
              api.post(config.bylBaseCenterPath, '/user/role/add/role/user', {roleId: that.$route.params.id, userIds: ids}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        } else {
          this.$toasted.show('没有删除项')
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        filters.roleId = this.$route.params.id
        var that = this
        api.post(config.bylBaseCenterPath, '/user/role/roles/user', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.cnt = r.cntData
          if (r.data) {
            that.tableData.data = r.data
            for (let i = 0; i < that.tableData.data.length; i++) {
              that.publicStateList.push(that.tableData.data[i])
            }
            for (let i = 0; i < that.publicStateList.length; i++) {
              var o = that.publicStateList[i]
              if (o.userName) {
                o.name = o.userName
              }
              o.type = '04'  // 用户
            }
          } else {
            that.tableData.data = []
          }
        })
      },
      resetList () {
        var that = this
        that.publicStateList = []  // 清空
        for (let i = 0; i < that.tableData.data.length; i++) { // 重置
          that.publicStateList.push(that.tableData.data[i])
        }
      },
      showRange () {
        var that = this
        this.resetList()
        this.$modal.show(ModalBox, {
          opts: {
            title: '分配角色',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.publicStateList, // 向组件内传入的数据, 一般用于初始化
              tabs: ['user']
            },
            yes (val) { // 点击确认后要做的事情
              that.publicStateList = val
              var ids = utils.grabVal(that.publicStateList, 'id')
              var names = utils.arr2str(utils.grabVal(that.publicStateList, 'name'))
              that.confirmBox({
                title: '确认',
                text: '确认将用户' + names + '设置为' + that.form.name + '吗?',
                yes: function () {
                  api.post(config.bylBaseCenterPath, '/user/role/add/role/user', {roleId: that.$route.params.id, userIds: ids}, function (r) { // 正常
                    that.$toasted.show('设置成功')
                    that.search(that.filters)
                    that.$modal.hide('dialog')
                  })
                }
              })
            },
            closed () {
              that.resetList()
            }
          }
        })
      },
      getModel (id) {
        var that = this
        api.get(config.bylBaseCenterPath, '/role/'  + id, null, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      }
    }
  }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/role/distribute.vue